import { Box, HStack, Input, StackProps, Text, VStack } from "@chakra-ui/react";
import { User } from "../../const/types";
import { useEffect, useState } from "react";
import NotFound from "../NotFound";
import ListItemPenggunaDashboard from "./ListItemPenggunaDashboard";

interface Props extends StackProps {
  data: User[];
  title?: string;
  status?: string;
}

export default function ListPenggunaDashboard({
  data,
  title,
  status,
  ...props
}: Props) {
  const [search, setSearch] = useState<string>("");
  const [filteredData, setFilteredData] = useState(data);
  useEffect(() => {
    const searchTerm = search.toLowerCase();
    const filtered = data.filter(
      (data) =>
        data.id.toString().includes(searchTerm) ||
        data.name.toLowerCase().includes(searchTerm)
    );
    setFilteredData(filtered);
  }, [search, data]);

  return (
    <VStack borderRadius={8} bg={"white"} align={"stretch"} gap={0} {...props}>
      <VStack gap={0} p={4} align={"stretch"}>
        <HStack mb={2} justify={"space-between"}>
          <Text fontWeight={500}>{title || `Pengguna`}</Text>

          {status && (
            <Box
              w={"10px"}
              h={"10px"}
              opacity={0.6}
              bg={status === "aktif" ? "green.500" : "red.500"}
              borderRadius={"full"}
            />
          )}
        </HStack>
        <Input
          placeholder="Pencarian"
          onChange={(e) => {
            setSearch(e.target.value);
          }}
          value={search}
        />
      </VStack>

      <VStack gap={0} align={"stretch"} overflowY={"auto"}>
        {filteredData && filteredData.length === 0 && <NotFound />}

        {filteredData &&
          filteredData.length > 0 &&
          filteredData.map((user, i) => (
            <ListItemPenggunaDashboard key={i} data={user} />
          ))}
      </VStack>

      
    </VStack>
  );
}
